module.exports = __webpack_public_path__ + "static/media/GrayEclipse.709cf0fb.svg";